import { createReducer } from "typesafe-actions";
import {
    CHANGE_NEED_CONFIRM_DIALOG_SETTINGS,
    HIDE_NEED_CONFIRM_DIALOG,
    SWITCH_DISPLAY_PERIOD_MARKETS
} from "../actions";
import { needConfirmDialogType, UserSettingsType } from "../types";
import { combineReducers } from "redux";
import { selectedTournamentReducer } from "./selectedTournamentReducer";
import {bannerHostPortReducer} from "./bannerHostPortReducer";


const userSettingsDefault = {
    displayPeriodMarkets: false,
    needConfirmDialog: {
        anchorElId: null,
    }
} as UserSettingsType;

export const displayPeriodMarketsReducer = createReducer<boolean>(userSettingsDefault.displayPeriodMarkets)
    .handleAction(SWITCH_DISPLAY_PERIOD_MARKETS, (state: boolean, action: {payload: {flag: boolean}}) => {
        return action.payload.flag;
    });

export const needConfirmDialogReducer = createReducer<needConfirmDialogType>(userSettingsDefault.needConfirmDialog)
    .handleAction(CHANGE_NEED_CONFIRM_DIALOG_SETTINGS, (state: needConfirmDialogType, action: {payload: {
            anchorElId: null,
        }}) => {
        return {
            anchorElId: action.payload.anchorElId
        };
    })
    .handleAction(HIDE_NEED_CONFIRM_DIALOG, () => ({
        anchorElId: null
    }));

export const appSettingsReducer = combineReducers<UserSettingsType>({
    displayPeriodMarkets: displayPeriodMarketsReducer,
    needConfirmDialog: needConfirmDialogReducer,
    selectedTournament: selectedTournamentReducer,
    bannerHostPort: bannerHostPortReducer
});